import { useState } from 'react';

import AdminSidebar from './AdminSidebar';

export default function AdminLayout({ children }) {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="flex min-h-screen bg-paper font-sans">
      <AdminSidebar
        collapsed={collapsed}
        onToggleCollapse={() => setCollapsed((c) => !c)}
      />
      <main className="flex-1 min-w-0 overflow-x-hidden pt-16 sm:pt-16 md:pt-0 lg:pt-0">
        <div className="p-4 sm:p-6 lg:p-8 max-w-screen-2xl mx-auto w-full">
          {children}
        </div>
      </main>
    </div>
  );
}
